import { Shield, Mail, Linkedin } from "lucide-react";

const quickLinks = [
  { label: "About", href: "#about" },
  { label: "Expertise", href: "#expertise" },
  { label: "Blog", href: "#blog" },
  { label: "Contact", href: "#contact" },
];

export default function Footer() {
  const handleClick = (href) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <footer className="bg-[#0F172A] text-white" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-20">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-8">
          {/* Logo */}
          <div>
            <div className="flex items-center gap-2 mb-3">
              <Shield className="w-5 h-5 text-[#06B6D4]" />
              <span className="font-['Outfit'] font-bold text-lg">Piyus Kumar</span>
            </div>
            <p className="text-sm text-white/50">ShiftLeft Security &middot; shiftleftsec.in</p>
          </div>

          {/* Quick links */}
          <div className="flex gap-6 items-start md:justify-center">
            {quickLinks.map((link) => (
              <button
                key={link.href}
                onClick={() => handleClick(link.href)}
                className="text-sm text-white/60 hover:text-[#06B6D4] transition-colors"
                data-testid={`footer-link-${link.label.toLowerCase()}`}
              >
                {link.label}
              </button>
            ))}
          </div>

          {/* Social */}
          <div className="flex gap-3 md:justify-end">
            <a
              href="https://linkedin.com/in/kumarpiyus"
              target="_blank"
              rel="noopener noreferrer"
              className="w-9 h-9 rounded-lg bg-white/10 flex items-center justify-center hover:bg-[#06B6D4]/20 transition-colors"
              data-testid="footer-linkedin"
            >
              <Linkedin className="w-4 h-4 text-white/70" />
            </a>
            <a
              href="mailto:piyush4855@gmail.com"
              className="w-9 h-9 rounded-lg bg-white/10 flex items-center justify-center hover:bg-[#06B6D4]/20 transition-colors"
              data-testid="footer-email"
            >
              <Mail className="w-4 h-4 text-white/70" />
            </a>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="mt-12 pt-6 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-white/40">&copy; 2026 Piyus Kumar &middot; ShiftLeft Security</p>
          <p className="text-xs text-white/30 italic">Built with coffee and a healthy paranoia about endpoints.</p>
        </div>
      </div>
    </footer>
  );
}
